import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext } from 'react';
import { createPortal } from 'react-dom';
import cn from 'classnames';
import styles from './Page.module.scss';
export const PageContentHeaderContext = /*#__PURE__*/ React.createContext(null);
/** Will render its content underneath the page header/subheader. Will be sticky to page top when scrolling. */ export const PageContentHeader = (param)=>{
    let { children, gapBelow = 'content', testId } = param;
    const contentHeader = useContext(PageContentHeaderContext);
    return contentHeader ? /*#__PURE__*/ createPortal(/*#__PURE__*/ _jsx("div", {
        className: cn({
            [styles.rowsBelow]: gapBelow === 'rows'
        }),
        "data-testid": testId,
        children: children
    }), contentHeader) : null;
};
